import React from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { ItemTypes } from './ItemTypes';
import ChartThumbnail from './chart-thumbnail.png';

const divStyle = {
  marginTop: 10,
  marginBottom: 15,
  backgroundColor: 'rgba(0,0,0,.1)',
  width: '100%',
  height: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
const LiveTrendChartShape = ({
  shape: { position, dimension, ...shape },
  isSelected,
  ...props
}) => {
  const [{ isDragging }, drag, preview] = useDrag(
    () => ({
      type: ItemTypes.SHAPE,
      item: {
        id: shape.id,
        position,
        name: shape.name,
      },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [shape.id, position.left, position.top, shape.name],
  );
  React.useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, []);
  let className = isSelected ? 'map-editor-shape--selected d-flex' : 'd-flex';
  let tagBoxStyle = {};
  const tagBoxSizeFormula = `calc(${shape.tagBoxSize}% - 0.5px)`;
  if (shape.tagLocation !== 'None') {
    switch (shape.tagLocation) {
      case 'Top':
        className += ' flex-column';
        tagBoxStyle.width = '100%';
        tagBoxStyle.height = tagBoxSizeFormula;
        break;
      default:
        className += ' flex-column-reverse';
        tagBoxStyle.width = '100%';
        tagBoxStyle.height = tagBoxSizeFormula;
        break;
    }
  }
  function getBorderBox(type) {
    let attr = '';
    let _attr = '';
    switch (shape.tagLocation) {
      case 'Top':
        attr = 'borderBottom';
        _attr = 'borderTop';
        break;
      case 'Right':
        attr = 'borderLeft';
        _attr = 'borderRight';
        break;
      case 'Bottom':
        attr = 'borderTop';
        _attr = 'borderBottom';
        break;
      case 'Left':
        attr = 'borderRight';
        _attr = 'borderLeft';
        break;
      default:
        break;
    }
    if (type === 0) {
      return Object.assign({}, { [attr]: '0.5px solid black' });
    } else {
      return Object.assign({}, { [_attr]: '0.5px solid black' });
    }
  }

  return (
    <div
      key={shape.id}
      id={shape.id}
      ref={drag}
      role="Shape"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onSelectShape({ position, dimension, ...shape });
      }}
      className={className}
      style={{
        position: 'absolute',
        ...position,
        ...dimension,
        ...shape,
        borderWidth: shape.borderSize,
        borderStyle: shape.borderStyle,
        borderColor: shape.borderColor,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {shape.tagLocation !== 'None' ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            ...tagBoxStyle,
            backgroundColor: shape.tagBackGroundColor,
            overflowY: 'hidden',
            lineHeight: 1,
            wordBreak: 'break-all',
            ...getBorderBox(0),
          }}
        >
          <span
            style={{
              fontSize: `${shape.tagFontSize}px`,
              color: shape.tagTextColor,
              fontFamily: shape.tagFontName,
            }}
          >
            {shape.tagText}
          </span>
        </div>
      ) : null}

      <div
        className="d-flex justify-content-center align-items-center w-100"
        style={{
          flex: 1,
          ...getBorderBox(1),
          height: `${100 - (shape.tagBoxSize || 0)}%`,
        }}
      >
        <img
          src={ChartThumbnail}
          alt="chart"
          className="w-100 h-100"
          style={{ objectFit: 'contain' }}
        />
      </div>
    </div>
  );
};

export default LiveTrendChartShape;
